
<template>
    <div id="printContract">
        <div class="logoHead">
            <img src="logoPrint.png" alt="logo go fix" class="lager">
        </div>
        <hr/>
        <h6>Contract Details</h6>
        <table border="0" width="100%" cellpadding="0" cellspacing="0">
            <tr>
                <td colspan="2"><label>Contract Name</label> {{clientContract.contract_name}}</td>
            </tr>
            <tr>
                <td colspan="2"><label>Client</label> {{ clientContract.client ? clientContract.client.name : 'n/a' }}</td>
            </tr>
            <tr>
                <td colspan="2"><label>LOA Date</label> {{ (clientContract.contract_terms && clientContract.contract_terms.length > 0  && clientContract.contract_terms[0].extra_info) ? clientContract.contract_terms[0].extra_info.loaDate : '' | formatsDate }}</td>
            </tr>
            <tr>
                <td><label>Agreement Signing Date</label> {{ (clientContract.contract_terms && clientContract.contract_terms.length > 0  && clientContract.contract_terms[0].extra_info) ? clientContract.contract_terms[0].extra_info.agreementDate : '' | formatsDate }}</td>
                <td><label>Contract Commencement Date</label> {{ (clientContract.contract_terms && clientContract.contract_terms.length > 0  && clientContract.contract_terms[0].extra_info) ? clientContract.contract_terms[0].start_date : '' | formatsDate }}</td>
            </tr>
            <tr>
                <td><label>Contract Sum</label> {{ (clientContract.contract_terms && clientContract.contract_terms.length > 0) ? $accounting.formatMoney(clientContract.contract_terms[0].contract_sum, { format: { pos : "%s %v", neg : "%s (%v)", zero: "n/a" } }) : 0 }}</td>
                <td><label>Contract Expiry date</label> {{ (clientContract.contract_terms && clientContract.contract_terms.length > 0  && clientContract.contract_terms[0].data) ? clientContract.contract_terms[0].end_date : '' | formatsDate }}</td>
            </tr>
        </table>
        <template v-for="(itemTerm, index) in clientContract.terms_option">
            <hr/>
            <h6>Option Period</h6>
            <table border="0" width="100%" cellpadding="0" cellspacing="0">
                <tr>
                    <td><label>Client Letter Date</label> {{ itemTerm.extra_info.clientLetterDate ? itemTerm.extra_info.clientLetterDate : '' | formatsDate }}</td>
                    <td><label>Contract Sum</label> {{itemTerm.contract_sum}}</td>
                </tr>
                <tr>
                    <td><label>Option Period Start Date</label> {{ itemTerm.start_date ? itemTerm.start_date : '' | formatsDate }}</td>
                    <td><label>Option Period End Date</label> {{ itemTerm.end_date ? itemTerm.end_date : '' | formatsDate }}</td>
                </tr>
            </table>
        </template>
        <template v-for="(itemTerm, index) in clientContract.extension_period_main">
            <hr/>
            <h6>Extension Period</h6>
            <table border="0" width="100%" cellpadding="0" cellspacing="0">
                <tr>
                    <td><label>Client Letter Date</label> {{ itemTerm.extra_info.clientLetterDate ? itemTerm.extra_info.clientLetterDate : '' | formatsDate }}</td>
                    <td><label>Contract Sum</label> {{itemTerm.contract_sum}}</td>
                </tr>
                <tr>
                    <td><label>Option Period Start Date</label> {{ itemTerm.start_date ? itemTerm.start_date : '' | formatsDate }}</td>
                    <td><label>Option Period End Date</label> {{ itemTerm.end_date ? itemTerm.end_date : '' | formatsDate }}</td>
                </tr>
            </table>
        </template>
        <template v-for="(item, index) in clientContract.extra_info">
            <hr/>
            <h6>Security Deposit</h6>
            <table border="0" width="100%" cellpadding="0" cellspacing="0">
                <tr>
                    <td><label>Type</label> {{ item.security_deposit ? item.security_deposit.json_content.type : 'n/a' }}</td>
                    <td><label>Banker Guarantee Sssuing Bank</label> {{ item.security_deposit ? item.security_deposit.json_content.issuing_bank : 'n/a' }}</td>
                </tr>
                <tr>
                    <td><label>Banker Guarantee Number</label> {{ item.security_deposit ? item.security_deposit.json_content.cheque_number : 'n/a' }}</td>
                    <td><label>Amount</label> {{ item.security_deposit ? item.security_deposit.json_content.amount : 'n/a' | formatMoney }}</td>
                </tr>
            </table>
            <hr class="widthHr" />
            <h6>Work injury compensation</h6>
            <table border="0" width="100%" cellpadding="0" cellspacing="0">
                <tr>
                    <td><label>Insurer</label> {{ item.work_injury_compensation ? item.work_injury_compensation.json_content.insurer : 'n/a' }}</td>
                    <td><label>Policy Number</label> {{ item.work_injury_compensation ? item.work_injury_compensation.json_content.policy_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td><label>Issue Date</label> {{ item.work_injury_compensation ? item.work_injury_compensation.json_content.issue_date : 'n/a' | formatsDate }}</td>
                    <td><label>Policy Premium</label> {{ item.work_injury_compensation ? item.work_injury_compensation.json_content.policy_premium : 'n/a' | formatMoney }}</td>
                </tr>
                <tr>
                    <td><label>Period Start Date</label> {{ item.work_injury_compensation ? item.work_injury_compensation.json_content.start_date : 'n/a' | formatsDate }}</td>
                    <td><label>Peposit End Date</label> {{ item.work_injury_compensation ? item.work_injury_compensation.json_content.end_date : 'n/a' | formatsDate }}</td>
                </tr>
                <tr>
                    <td><label>Policy Premium Reciept Number</label> {{ item.work_injury_compensation ? item.work_injury_compensation.json_content.policy_receipt : 'n/a' }}</td>
                    <td>&nbsp</td>
                </tr>
            </table>
            <hr class="widthHr" />
            <h6>Public Liability Claim Insurance</h6>
            <table border="0" width="100%" cellpadding="0" cellspacing="0">
                <tr>
                    <td><label>Insurer</label> {{ item.public_liability_claim_insurance ? item.public_liability_claim_insurance.json_content.insurer : 'n/a' }}</td>
                    <td><label>Policy Number</label> {{ item.public_liability_claim_insurance ? item.public_liability_claim_insurance.json_content.policy_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td><label>Issue Date</label> {{ item.public_liability_claim_insurance ? item.public_liability_claim_insurance.json_content.issue_date : 'n/a' | formatsDate }}</td>
                    <td><label>Policy Premium</label> {{ item.public_liability_claim_insurance ? item.public_liability_claim_insurance.json_content.policy_premium : 'n/a' | formatMoney }}</td>
                </tr>
                <tr>
                    <td><label>Period Start Date</label> {{ item.public_liability_claim_insurance ? item.public_liability_claim_insurance.json_content.start_date : 'n/a' | formatsDate }}</td>
                    <td><label>Deposit End Date</label> {{ item.public_liability_claim_insurance ? item.public_liability_claim_insurance.json_content.end_date : 'n/a' | formatsDate }}</td>
                </tr>
                <tr>
                    <td><label>Policy Premium Reciept Number</label> {{ item.public_liability_claim_insurance ? item.public_liability_claim_insurance.json_content.policy_receipt : 'n/a' }}</td>
                    <td>&nbsp</td>
                </tr>
            </table>
        </template>
        <template v-for="(item, index) in clientContract.contract_variation_info">
            <hr/>
            <h6>Contract Variation</h6>
            <table border="0" width="100%" cellpadding="0" cellspacing="0">
                <tr>
                    <td><label>Amount</label> {{ item.json_content.amount | formatMoney }}</td>
                    <td><label>Client</label> {{ item.json_content.description }}</td>
                </tr>
            </table>
        </template>
    </div>
</template>
<script>
    import Printd from 'printd'
    const d = new Printd()
    import moment from 'moment';
    export default {
        name: 'contract-print',
        props: {
            clientContract: {
                type: Object,
                required: true,
                default: () => {}
            }
        },
        data() {
            return {
                cssText: ` @page { size: auto;  margin: 0mm 0mm 0mm 0mm; } table { font-size: 10px; line-height: 15px; margin: 0 50px; font-family: Helvertica; } table > tr > td { padding: 5px 0; width: 50%; }  h6 { margin-left: 50px; font-weight: bold; font-size: 10px; line-height: 12px; color: #666; text-transform: capitalize; margin-bottom: 10px; } label { font-weight: nomal; font-size: 10px; line-height: 12px; color: #666; letter-spacing: 0.15px; margin-right: 20px; } hr { margin-bottom: 13px; } .logoHead { margin-top: 20px; margin-left: 20px; } a { color: #fff!important; } .widthHr { width: 90%; } `,
            }
        },
        filters: {
            formatsDate: function(value) {
                if (!value) return "N/A";
                return moment(new Date(value)).format("DD.MM.YYYY");
            }
        },
        methods: {
            print () {
                d.print(document.getElementById('printContract'), [this.cssText])
            }
        }
    }
</script>
